//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import ProfileOverviewLazy from "~/components/profile/mixins/ProfileOverviewLazy"

//import {VueAgile} from "vue-agile"

export default {

    name: 'ProfileProducts',

    mixins: [ProfileData, ProfileOverviewLazy],

    //components: { agile: VueAgile },

    props: {
        company: {
        },
        destination: {
        },
    },

    data() {
        return {
            products: {},
            agileOptions: {
                autoplay: false,
                dots: true,
                navButtons: true,
                slidesToShow: 3,
                infinite: false,
            }
        }
    },

    async fetch() {
        this.getData()
    },

    methods: {

        async getData() {

            if(this.visible === false) {
                return
            }

            try {
                const response = await this.$store.dispatch('profile/GET_PRODUCTS', this.company.id)
                this.products = response
            } catch (e) {
                this.$logger.captureException(e)
            }

            this.isReady = true

        },

    },

    computed: {

    }

}

